import { render, staticRenderFns } from "./ConfirmAddDefault.vue?vue&type=template&id=6a68d870"
import script from "./ConfirmAddDefault.vue?vue&type=script&lang=js"
export * from "./ConfirmAddDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports